export const mobile_homepage_anchor = {
    adUnitName: "YD_Homepage_Anchor",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "www_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "www.yourdictionary.com/",
};

export const desktop_sentence_home_banner = {
    adUnitName: "YD_Sentence_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/",
};

export const desktop_sentence_home_topright = {
    adUnitName: "YD_Sentence_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "sentence_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/",
};

export const mobile_sentence_home_incontent_top = {
    adUnitName: "YD_Sentence_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/",
};

export const mobile_sentence_home_anchor = {
    adUnitName: "YD_Sentence_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/",
};

export const desktop_sentence_index_banner = {
    adUnitName: "YD_Sentence_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_index_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/index/*",
};

export const mobile_sentence_index_anchor = {
    adUnitName: "YD_Sentence_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_index_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/index/*",
};

export const desktop_sentence_detail_banner = {
    adUnitName: "YD_Sentence_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const desktop_sentence_detail_topright = {
    adUnitName: "YD_Sentence_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const desktop_sentence_detail_btf = {
    adUnitName: "YD_Sentence_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const desktop_sentence_detail_sticky = {
    adUnitName: "YD_Sentence_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const desktop_sentence_detail_native = {
    adUnitName: "YD_Sentence_Native",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const mobile_sentence_detail_incontent_top = {
    adUnitName: "YD_Sentence_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const mobile_sentence_detail_incontent_middle = {
    adUnitName: "YD_Sentence_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const mobile_sentence_detail_anchor = {
    adUnitName: "YD_Sentence_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const desktop_thesaurus_home_banner = {
    adUnitName: "YD_Thesaurus_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/",
};

export const desktop_thesaurus_home_topright = {
    adUnitName: "YD_Thesaurus_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "thesaurus_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/",
};

export const mobile_thesaurus_home_incontent_top = {
    adUnitName: "YD_Thesaurus_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/",
};

export const mobile_thesaurus_home_anchor = {
    adUnitName: "YD_Thesaurus_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/",
};

export const desktop_thesaurus_index_banner = {
    adUnitName: "YD_Thesaurus_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_index_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/index/*",
};

export const mobile_thesaurus_index_anchor = {
    adUnitName: "YD_Thesaurus_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_index_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/index/*",
};

export const desktop_thesaurus_detail_banner = {
    adUnitName: "YD_Thesaurus_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/{word}",
};

export const desktop_thesaurus_detail_topright = {
    adUnitName: "YD_Thesaurus_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/{word}",
};

export const desktop_thesaurus_detail_btf = {
    adUnitName: "YD_Thesaurus_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/{word}",
};

export const desktop_thesaurus_detail_sticky = {
    adUnitName: "YD_Thesaurus_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/{word}",
};

export const mobile_thesaurus_detail_incontent_top = {
    adUnitName: "YD_Thesaurus_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const mobile_thesaurus_detail_incontent_middle = {
    adUnitName: "YD_Thesaurus_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "sentence.yourdictionary.com/{word}",
};

export const mobile_thesaurus_detail_anchor = {
    adUnitName: "YD_Thesaurus_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/{word}",
};

export const desktop_thesaurus404_banner = {
    adUnitName: "YD_Thesaurus404_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/404/no-results",
};

export const desktop_thesaurus404_topright = {
    adUnitName: "YD_Thesaurus404_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/404/no-results",
};

export const mobile_thesaurus404_anchor = {
    adUnitName: "YD_Thesaurus404_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "thesaurus_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "thesaurus.yourdictionary.com/404/no-results",
};

export const mobile_es_homepage_anchor = {
    adUnitName: "YD_ES_Homepage_Anchor",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "es_home_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/",
};

export const desktop_es_sentence_detail_banner = {
    adUnitName: "YD_ES_Sentence_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "es_sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/{word}",
};

export const desktop_es_sentence_detail_topright = {
    adUnitName: "YD_ES_Sentence_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "es_sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/{word}",
};

export const desktop_es_sentence_detail_btf = {
    adUnitName: "YD_ES_Sentence_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "es_sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/{word}",
};

export const desktop_es_sentence_detail_sticky = {
    adUnitName: "YD_ES_Sentence_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "es_sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/{word}",
};

export const mobile_es_sentence_detail_incontent_top = {
    adUnitName: "YD_ES_Sentence_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "es_sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/{word}",
};

export const mobile_es_sentence_detail_incontent_middle = {
    adUnitName: "YD_ES_Sentence_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "es_sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/{word}",
};

export const mobile_es_sentence_detail_anchor = {
    adUnitName: "YD_ES_Sentence_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "es_sentence_detail_v_{expChannel}",
    keyB: undefined,
    valueB: undefined,
    urlLocation: "es.yourdictionary.com/{word}",
};

export const desktop_article_detail_banner = {
    adUnitName: "YD_Reference_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "abbreviations",
    urlLocation: "abbreviations.yourdictionary.com/articles/*",
};

export const desktop_article_detail_topright = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "abbreviations",
    urlLocation: "abbreviations.yourdictionary.com/articles/*",
};

export const desktop_article_detail_btf = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "abbreviations",
    urlLocation: "abbreviations.yourdictionary.com/articles/*",
};

export const desktop_article_detail_sticky = {
    adUnitName: "YD_Reference_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "abbreviations",
    urlLocation: "abbreviations.yourdictionary.com/articles/*",
};

export const mobile_article_detail_incontent_top = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "abbreviations",
    urlLocation: "abbreviations.yourdictionary.com/articles/*",
};

export const mobile_article_detail_incontent_middle = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "abbreviations",
    urlLocation: "abbreviations.yourdictionary.com/articles/*",
};

export const mobile_article_detail_anchor = {
    adUnitName: "YD_Reference_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "abbreviations",
    urlLocation: "abbreviations.yourdictionary.com/articles/*",
};

export const desktop_reference_detail_banner = {
    adUnitName: "YD_Reference_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "reference ",
    urlLocation: "reference.yourdictionary.com/*",
};

export const desktop_reference_detail_topright = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "reference ",
    urlLocation: "reference.yourdictionary.com/*",
};

export const desktop_reference_detail_btf = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "reference ",
    urlLocation: "reference.yourdictionary.com/*",
};

export const desktop_reference_detail_sticky = {
    adUnitName: "YD_Reference_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "reference ",
    urlLocation: "reference.yourdictionary.com/*",
};

export const mobile_reference_detail_incontent_top = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "reference ",
    urlLocation: "reference.yourdictionary.com/*",
};

export const mobile_reference_detail_incontent_middle = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "reference ",
    urlLocation: "reference.yourdictionary.com/*",
};

export const mobile_reference_detail_anchor = {
    adUnitName: "YD_Reference_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "reference ",
    urlLocation: "reference.yourdictionary.com/*",
};

export const desktop_biography_detail_banner = {
    adUnitName: "YD_Reference_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "biography ",
    urlLocation: "biography.yourdictionary.com/*",
};

export const desktop_biography_detail_topright = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "biography ",
    urlLocation: "biography.yourdictionary.com/*",
};

export const desktop_biography_detail_btf = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "biography ",
    urlLocation: "biography.yourdictionary.com/*",
};

export const desktop_biography_detail_sticky = {
    adUnitName: "YD_Reference_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "biography ",
    urlLocation: "biography.yourdictionary.com/*",
};

export const mobile_biography_detail_incontent_top = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "biography ",
    urlLocation: "biography.yourdictionary.com/*",
};

export const mobile_biography_detail_incontent_middle = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "biography ",
    urlLocation: "biography.yourdictionary.com/*",
};

export const mobile_biography_detail_anchor = {
    adUnitName: "YD_Reference_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "biography ",
    urlLocation: "biography.yourdictionary.com/*",
};

export const desktop_esl_detail_banner = {
    adUnitName: "YD_Reference_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "esl",
    urlLocation: "esl.yourdictionary.com",
};

export const desktop_esl_detail_topright = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "esl",
    urlLocation: "esl.yourdictionary.com",
};

export const desktop_esl_detail_btf = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "esl",
    urlLocation: "esl.yourdictionary.com",
};

export const desktop_esl_detail_sticky = {
    adUnitName: "YD_Reference_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "esl",
    urlLocation: "esl.yourdictionary.com",
};

export const mobile_esl_detail_incontent_top = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "esl",
    urlLocation: "esl.yourdictionary.com",
};

export const mobile_esl_detail_incontent_middle = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "esl",
    urlLocation: "esl.yourdictionary.com",
};

export const mobile_esl_detail_anchor = {
    adUnitName: "YD_Reference_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "esl",
    urlLocation: "esl.yourdictionary.com",
};

export const desktop_education_detail_banner = {
    adUnitName: "YD_Reference_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "education ",
    urlLocation: "education.yourdictionary.com",
};

export const desktop_education_detail_topright = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "education ",
    urlLocation: "education.yourdictionary.com",
};

export const desktop_education_detail_btf = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "education ",
    urlLocation: "education.yourdictionary.com",
};

export const desktop_education_detail_sticky = {
    adUnitName: "YD_Reference_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "education ",
    urlLocation: "education.yourdictionary.com",
};

export const mobile_education_detail_incontent_top = {
    adUnitName: "YD_Reference_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "education ",
    urlLocation: "education.yourdictionary.com",
};

export const mobile_education_detail_incontent_middle = {
    adUnitName: "YD_Reference_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "education ",
    urlLocation: "education.yourdictionary.com",
};

export const mobile_education_detail_anchor = {
    adUnitName: "YD_Reference_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "reference_detail_v_{expChannel}",
    keyB: "page",
    valueB: "education ",
    urlLocation: "education.yourdictionary.com",
};

export const desktop_grammar_detail_banner = {
    adUnitName: "YD_Grammar_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "grammar_detail_{expChannel}",
    keyB: "page",
    valueB: "grammar",
    urlLocation: "grammar.yourdictionary.com/",
};

export const desktop_grammar_detail_topright = {
    adUnitName: "YD_Grammar_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "grammar_detail_{expChannel}",
    keyB: "page",
    valueB: "grammar",
    urlLocation: "grammar.yourdictionary.com/",
};

export const desktop_grammar_detail_btf = {
    adUnitName: "YD_Grammar_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "grammar_detail_{expChannel}",
    keyB: "page",
    valueB: "grammar",
    urlLocation: "grammar.yourdictionary.com/",
};

export const desktop_grammar_detail_sticky = {
    adUnitName: "YD_Grammar_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "grammar_detail_{expChannel}",
    keyB: "page",
    valueB: "grammar",
    urlLocation: "grammar.yourdictionary.com/",
};

export const mobile_grammar_detail_anchor = {
    adUnitName: "YD_Grammar_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "grammar_detail_{expChannel}",
    keyB: "page",
    valueB: "grammar",
    urlLocation: "grammar.yourdictionary.com/",
};

export const mobile_grammar_detail_incontent_top = {
    adUnitName: "YD_Grammar_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "grammar_detail_{expChannel}",
    keyB: "page",
    valueB: "grammar",
    urlLocation: "grammar.yourdictionary.com/",
};

export const mobile_grammar_detail_incontent_middle = {
    adUnitName: "YD_Grammar_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "grammar_detail_{expChannel}",
    keyB: "page",
    valueB: "grammar",
    urlLocation: "grammar.yourdictionary.com/",
};

export const desktop_examples_detail_banner = {
    adUnitName: "YD_Examples_728",
    widthA: 728,
    heightA: 90,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "examples_detail_{expChannel}",
    keyB: "page",
    valueB: "examples",
    urlLocation: "examples.yourdictionary.com/",
};

export const desktop_examples_detail_topright = {
    adUnitName: "YD_Examples_300",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "examples_detail_{expChannel}",
    keyB: "page",
    valueB: "examples",
    urlLocation: "examples.yourdictionary.com/",
};

export const desktop_examples_detail_btf = {
    adUnitName: "YD_Examples_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "examples_detail_{expChannel}",
    keyB: "page",
    valueB: "examples",
    urlLocation: "examples.yourdictionary.com/",
};

export const desktop_examples_detail_sticky = {
    adUnitName: "YD_Examples_Sticky",
    widthA: 300,
    heightA: 600,
    widthB: 300,
    heightB: 250,
    widthC: 160,
    heightC: 600,
    keyA: "page_variation",
    valueA: "examples_detail_{expChannel}",
    keyB: "page",
    valueB: "examples",
    urlLocation: "examples.yourdictionary.com/",
};

export const mobile_examples_detail_anchor = {
    adUnitName: "YD_Examples_728",
    widthA: 300,
    heightA: 50,
    widthB: 320,
    heightB: 50,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "examples_detail_{expChannel}",
    keyB: "page",
    valueB: "examples",
    urlLocation: "examples.yourdictionary.com/",
};

export const mobile_examples_detail_incontent_top = {
    adUnitName: "YD_Examples_300",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "examples_detail_{expChannel}",
    keyB: "page",
    valueB: "examples",
    urlLocation: "examples.yourdictionary.com/",
};

export const mobile_examples_detail_incontent_middle = {
    adUnitName: "YD_Examples_300_BTF",
    widthA: 300,
    heightA: 250,
    widthB: undefined,
    heightB: undefined,
    widthC: undefined,
    heightC: undefined,
    keyA: "page_variation",
    valueA: "examples_detail_{expChannel}",
    keyB: "page",
    valueB: "examples",
    urlLocation: "examples.yourdictionary.com/",
};




// WEBPACK FOOTER //
// ./src/common/adsInventory.js